import { Controller } from "@hotwired/stimulus"
import { template } from "lodash"
import { forceSetValueOnSelect, parseNumber, formatNumber } from "./../helpers"

export default class extends Controller {
  static targets = ["productId", "positionMore", "buttonLess", "buttonMore", "decidesEmpty", "taxField", "newPosition", "totalPriceNet", "totalPriceGross",
    "summaryAfterDiscount", "summaryNet", "summaryNetDiscounted", "summaryGross", "summaryGrossDiscounted", "summaryTotalDiscountGross", "summaryTax",
    "summaryTaxDiscounted", "showDiscount", "item", "arrDueRow", "arrDueLabel", "arrDueAmount"
  ]

  static outlets = ["invoice"]

  static values = {
    positionsLimit: { type: Number, default: 10 },
    positionId: Number,
    positionIndex: String,
    positionKind: String,
    reverseCharge: Boolean,
    arrFeeRate: String,
    arrDueLabelPrefix: String
  }

  /** @type {HTMLElement} */
  positionObject = null
  newPositionId
  separatorTemplate
  subtotalAlertTemplate
  prevPositionKind

  get positionsContainer() {
    return this.invoiceOutlet.positionsContainerTarget
  }

  get taxVisible() {
    return this.invoiceOutlet.taxVisibleValue
  }

  get departments() {
    return this.invoiceOutlet.departmentsValue
  }

  get isTemplate() {
    return this.positionObject !== null
  }

  get priceSetup() {
    return this.invoiceOutlet.priceSetupValue
  }

  connect() {
    console.log('invoice-position connect')
    if (document.querySelector("template[data-target='subtotalAlertTemplate']")) {
      this.subtotalAlertTemplate = template(document.querySelector("template[data-target='subtotalAlertTemplate']").innerHTML)
    }

    if (document.querySelector("template[data-target='separatorTemplate']")) {
      this.separatorTemplate = template(document.querySelector("template[data-target='separatorTemplate']").innerHTML)
    }

    if (!this.isTemplate && this.hasNewPositionTarget) {
      this.newPositionId = this.positionIdValue
      this.preparePositionToCopy()
    }

    if (this.hasInvoiceOutlet) {
      this.attachDiscountListener(this.invoiceOutlet)
    }

    document.addEventListener("position-description:removed", this.onDescriptionRemoved = () => {
      document.getElementById("add-position-descriptions-option")?.classList.remove("hidden")
    })
  }

  invoiceOutletConnected(outlet) {
    this.attachDiscountListener(outlet)
  }

  attachDiscountListener(outlet) {
    if (this.onDiscountChanged || !outlet.hasDiscountTarget) return
    this.onDiscountChanged = () => this.syncDiscountVisibility()
    outlet.discountTarget.addEventListener("change", this.onDiscountChanged)
  }

  handleReverseChargeChanged(event) {
    this.reverseChargeValue = event.detail.checked
  }

  disconnect() {
    document.removeEventListener("position-description:removed", this.onDescriptionRemoved)
    if (this.onDiscountChanged && this.hasInvoiceOutlet && this.invoiceOutlet.hasDiscountTarget) {
      this.invoiceOutlet.discountTarget.removeEventListener("change", this.onDiscountChanged)
    }
  }

  syncDiscountVisibility() {
    const checked = this.invoiceOutlet.discountTarget.checked
    this.invoiceOutlet.discountElemTargets.forEach(el => el.classList.toggle("hidden", !checked))
    this.summaryAfterDiscountTargets.forEach(el => el.classList.toggle("hidden", !checked))
  }

  preparePositionToCopy() {
    const positionTemplate = document.getElementById("detail_" + this.positionIdValue + "_")
    if (!this.positionObject && positionTemplate) {
      this.positionObject = positionTemplate.cloneNode(true)
      this.positionObject.classList.remove("hidden")
      positionTemplate.remove()
    }
  }

  add(event) {
    this.prevPositionKind = document.getElementById(`invoice_positions_attributes_${this.newPositionId - 1}_kind`)?.value

    if (event.params.positionKind === "text") {
      let newPosition = this.positionObject.outerHTML
      newPosition = this.replaceAll(newPosition, '_' + this.positionIdValue + '_', '_' + this.newPositionId + '_')
      newPosition = this.replaceAll(newPosition, '[' + this.positionIdValue + ']', '[' + this.newPositionId + ']')
      this.positionsContainer.insertAdjacentHTML('beforeend', newPosition)
      this.actionsAfterAddingPosition(this.newPositionId)
    } else {
      const newPosition = this.separatorTemplate({
        key: this.newPositionId,
        kind: event.params.positionKind,
        value: event.params.positionValue
      })
      this.positionsContainer.insertAdjacentHTML('beforeend', newPosition)
      if (event.params.positionKind === "subtotal_with_quantity") {
        this.subtotalWithQuantityAlert()
      }
      if (event.params.positionKind === "subtotal_with_weight") {
        document.getElementById(`invoice_positions_attributes_${this.newPositionId}_quantity_unit`).value = event.params.positionUnit
      }
    }
    this.newPositionId += 1
    this.checkPositionLimit(event.currentTarget)
  }

  delete(event) {
    const confirmed = confirm(event.currentTarget.getAttribute("data-confirm"))
    if (confirmed) {
      document.getElementById("detail" + event.params.index).classList.add("hidden")
      document.querySelector(".delete_check_box" + event.params.index).checked = true

      document.getElementById("invoice_positions_attributes" + event.params.index + "total_price_net").value = ""
      document.getElementById("invoice_positions_attributes" + event.params.index + "total_price_gross").value = ""
      document.getElementById("invoice_positions_attributes" + event.params.index + "discount").value = ""

      // TODO
      // if( ['service_with_products', 'services_product'].includes(pos_kind) ){

      //   if( pos_kind == 'service_with_products' ){
      //     var sp_container = $(el).closest('.product-related-to-service');
      //     sp_container.find('.services-product [id$=__destroy]').prop('checked', true);
      //     sp_container.slideUp();
      //     sp_container.find('.services-product [id$=_total_price_net], .services-product [id$=_total_price_gross]').val('');
      //   }

      //   compute_service_with_product_name('#invoice_positions_attributes_' + j + '_name', {deleted: true});
      //   sum_products(j, '<%= @invoice.kind %>', <%= calculating_strategy_json_html_safe %>);

      // }

      // TODO if @invoice.jpk_codes_enabled?

      if (this.hasSummaryNetTarget) {
        this.calculateTotalSum()
      }

      // Sprawdź notice o braku jednostki po usunięciu pozycji
      this.invoiceOutlet.checkEmptyUnitNotice()
    }
  }

  checkPositionLimit(elem) {
    if (this.positionsLimitValue === this.newPositionId) {
      elem.remove()
    }
  }

  actionsAfterAddingPosition(i, options) {
    if (options == null) {
      options = {}
    }

    // wiersze są zawsze dopisywane na koniec (insertAdjacentHTML "beforeend") i nigdy nie są
    // usuwane z DOM (delete tylko chowa), więc itemTargets[i] to zawsze świeżo dodany wiersz
    const newRow = this.itemTargets[i]
    if (newRow) {
      newRow.setAttribute("data-invoice--position-calculator-reverse-charge-value", this.reverseChargeValue)
    }

    this.invoiceOutlet.invoiceTaxRateOutlet.updateTechnicalTaxVisibility()
    this.invoiceOutlet.invoiceTaxRateOutlet.captureTechnicalTax()

    if (this.taxVisible && this.invoiceOutlet.hasDepartmentSelectTarget) {
      const dep = this.invoiceOutlet.departmentSelectTarget.value
      if (this.departments[dep] && options["set_taxes"] !== false) {
        // dokument z wymuszoną stawką (RR: ryczałt); bez tej gałęzi forceSetValueOnSelect DOKLEIŁBY stawkę
        // działu jako nową opcję selecta (helpers.js) i zostałaby wybieralna, mimo późniejszej korekty wartości
        const deptTax = this.invoiceOutlet.forcedPositionTaxValue || this.departments[dep].default_tax
        forceSetValueOnSelect(document.getElementById("invoice_positions_attributes_" + i + "_tax"), deptTax)
        document.getElementById("invoice_positions_attributes_" + i + "_tax").dispatchEvent(new Event("change"))
      }
    }

    if (this.invoiceOutlet.hasMossOutlet) {
      const mossController = this.invoiceOutlet.mossOutlet
      if (options['set_taxes'] !== false) {
        if (i > 0) {
          if (this.prevPositionKind === "" && document.getElementById(`invoice_positions_attributes_${i - 1}_tax`).options) {
            document.getElementById(`invoice_positions_attributes_${i}_tax`).replaceChildren(...Array.from(document.getElementById(`invoice_positions_attributes_${i - 1}_tax`).options).map(e => e.cloneNode(true)))
          }
        } else if (mossController.useMossTarget.checked) {
          if (mossController.recipientCountry) {
            mossController.setMossTaxes(mossController.recipientCountry)
          } else {
            mossController.setMossTaxes(this.invoiceOutlet.buyerCountryTarget.value)
          }
        } else {
          mossController.setDefaultTaxes()
        }
      }
    }

    // Dwie reguły korzystające z tej samej pary pól, więc liczone raz: (1) kopiujemy zablokowaną
    // opcję z SĄSIEDNIEGO wiersza, a nie polegamy tylko na position_calculator_controller#connect()
    // (który blokuje pole do WŁASNEJ wartości) — klon szablonu nowej pozycji może connect()-ować
    // się zanim jego atrybut reverse-charge-value zostanie ustawiony, więc bez tej kopii nowy
    // wiersz mógłby odziedziczyć nieprawidłową (niezablokowaną) listę opcji; (2) jeśli poprzednia
    // pozycja ma nietypową stawkę spoza domyślnej listy, dodajemy ją do selecta nowej pozycji.
    // W obu regułach pomijamy poprzednika z tax="disabled" (separator albo pozycja z wyłączonym
    // podatkiem) jako źródło do skopiowania — inaczej nowa, prawdziwa pozycja dostałaby "disabled"
    // zamiast poprawnej stawki (poprawia to dalszy fix "positionKind" dla pozycji po separatorze,
    // ale po niepotrzebnym nadpisaniu na "disabled" w międzyczasie).
    const prevTaxField = document.getElementById(`invoice_positions_attributes_${i - 1}_tax`)
    const newTaxField = document.getElementById(`invoice_positions_attributes_${i}_tax`)

    if (prevTaxField && newTaxField && prevTaxField.value !== "disabled") {
      if (this.reverseChargeValue) {
        if (prevTaxField.matches("select")) {
          newTaxField.replaceChildren(...Array.from(prevTaxField.options).map(e => e.cloneNode(true)))
        } else {
          forceSetValueOnSelect(newTaxField, prevTaxField.value)
        }
      }

      if (!Array.from(newTaxField.children).map(x => x.value).includes(prevTaxField.value)) {
        forceSetValueOnSelect(newTaxField, prevTaxField.value)
      }
    }

    if (this.invoiceOutlet.hasDepartmentSelectTarget) {
      const dep = this.invoiceOutlet.departmentSelectTarget.value
      const newTaxField = document.getElementById(`invoice_positions_attributes_${i}_tax`)
      if (newTaxField) this.invoiceOutlet.invoiceTaxRateOutlet.forceFrTaxOnNewPosition(newTaxField, this.departments[dep])
    }

    // fix do ustawiania tax na disabled dla pozycji dodanych po separatorach (page_break, subtotal)
    const positionKind = document.querySelector(`#invoice_positions_attributes_${i - 1}_kind`)?.value

    if (positionKind && !["service_with_products", "services_product"].includes(positionKind)) {
      const elements = Array.from(document.querySelectorAll("[id^=invoice_positions_attributes_][id$='_kind']:not([value])")).reverse().slice(1)
      let indexMatch = elements[0].getAttribute("name").match(/\[(\d+)\]/)
      indexMatch = parseInt(indexMatch[1], 10)
      forceSetValueOnSelect(document.querySelector(`#invoice_positions_attributes_${i}_tax`),
        document.getElementById(`invoice_positions_attributes_${indexMatch}_tax`).value)

      // TODO set_taxes
      //   if(options['set_taxes'] !== false){
      //     $('#invoice_positions_attributes_'+(i)+'_tax').val($('#invoice_positions_attributes_'+(i-index-1)+'_tax').val());
      //     <% if @invoice.tax2_visible? %>
      //       $('#invoice_positions_attributes_'+(i)+'_tax2').val($('#invoice_positions_attributes_'+(i-index-1)+'_tax2').val());
      //     <% end %>
      //   }
      //   return false;
    }

    if (this.prevPositionKind === "") {
      const prevUnitEl = document.getElementById("invoice_positions_attributes_" + (i - 1) + "_quantity_unit")
      const prevUnit = prevUnitEl ? prevUnitEl.value : null
      const unit = prevUnit !== null ? prevUnit : (this.hasInvoiceOutlet && this.invoiceOutlet.defaultProductUnitValue)
      if (unit) {
        forceSetValueOnSelect(document.getElementById("invoice_positions_attributes_" + i + "_quantity_unit"), unit)
      } else {
        document.getElementById("invoice_positions_attributes_" + i + "_quantity_unit").value = ""
      }

      document.getElementById("invoice_positions_attributes_" + i + "_discount_percent").value = document.getElementById("invoice_positions_attributes_" + (i - 1) + "_discount_percent").value
      document.getElementById("invoice_positions_attributes_" + i + "_discount").value = document.getElementById("invoice_positions_attributes_" + (i - 1) + "_discount").value
    }

    if (this.invoiceOutlet.hasDiscountElemTarget && this.invoiceOutlet.hasDiscountTarget && this.invoiceOutlet.discountTarget.checked) {
      document.querySelector("div[data-invoice-target=\"discountElem\"].hidden")?.classList.remove("hidden")
    }

    // TODO dla korekty
    // handleReverseChargeOnCorrections([i])

    // TODO jpk i korekta
    // var corAfterGtuEl = $("[name = 'invoice[positions_attributes]["+ i +"][correction_after_attributes][gtu_code]']").first();
    // corAfterGtuEl.addClass("gtu-codes")
    // corAfterGtuEl.change(function(){ handlePositionGtuCodesChange(corAfterGtuEl) });
    this.invoiceOutlet.fillWithDefaultTax(i)
    this.invoiceOutlet.checkEmptyUnitNotice()

    const anyDescriptionVisible = document.querySelector(
      "[data-controller~='invoice--position-description']:not(.hidden)"
    )
    if (anyDescriptionVisible) {
      requestAnimationFrame(() => {
        const newDetail = document.getElementById("detail_" + i + "_")
        const newDescWrapper = newDetail?.querySelector(
          "[data-controller~='invoice--position-description']"
        )
        if (newDescWrapper) {
          newDescWrapper.setAttribute("data-invoice--position-description-visible-value", "true")
        }
      })
    }
  }

  addPositionDescriptions() {
    document.dispatchEvent(new CustomEvent("position-descriptions:show-all"))
    document.getElementById("add-position-descriptions-option")?.classList.add("hidden")
  }

  replaceAll(str, from, to) {
    if (from === to) {
      return str
    }
    let idx = str.indexOf(from)
    let j = 0
    while (idx > -1) {
      str = str.replace(from, to)
      idx = str.indexOf(from)
      j++
      if (j > 1000) {
        return str
      }
      //bezpiecznik
    }
    return str
  }

  subtotalWithQuantityAlert() {
    let lastQuantity = null
    let different = false

    document.querySelectorAll("[id^=detail_]").forEach((element) => {
      if (window.getComputedStyle(element).display === "none") {
        return
      }

      const currentKind = element.querySelector("[id$=_kind]").value
      if (currentKind === "text_separator" || currentKind === "page_break") {
        return
      }

      if (currentKind === "subtotal_with_quantity") {
        const name = element.querySelector("[id$=_name]")
        name.parentNode.insertAdjacentHTML('beforeend', this.subtotalAlertTemplate())
        element.querySelector(".subtotal_alert").classList.toggle("hidden", !different)

        lastQuantity = null
        different = false
      } else if (currentKind === "subtotal" || currentKind === "subtotal_with_weight") {
        lastQuantity = null
        different = false
      } else {
        const currentQuantity = (element.querySelector("[id$=_quantity_unit]").value || "")

        if (lastQuantity === null) {
          lastQuantity = currentQuantity
        } else if (lastQuantity !== currentQuantity) {
          different = true
        }
      }
    })
  }

  calculateTotalSum() {
    let net = 0 // suma netto przed rabatem
    let gross = 0 // suma brutto przed rabatem
    let netDiscounted = 0 // suma netto po rabacie
    let grossDiscounted = 0 // suma brutto suma netto po rabacie
    const discountVisible = this.invoiceOutlet.hasDiscountTarget && this.invoiceOutlet.discountTarget.checked // czy pole na rabat jest widoczne ([0] to nagłówek)
    const isCorrection = this.kindValue === "correction" // czy korekta

    this.totalPriceNetTargets.forEach(el => {
      net += parseNumber(el.value, this.priceSetup)
    })
    this.totalPriceGrossTargets.forEach(el => {
      gross += parseNumber(el.value, this.priceSetup)
    })

    // jeżeli są pola na discount -> invoice'y
    if (discountVisible) {
      if (isCorrection) { // TODO korekta
        const discountedBefore = this.calcDiscounted("_correction_before_attributes")
        const discountedAfter = this.calcDiscounted("_correction_after_attributes")
        netDiscounted = discountedAfter[0] - discountedBefore[0]
        grossDiscounted = discountedAfter[1] - discountedBefore[1]
      } else {
        const discounted = this.calcDiscounted()
        netDiscounted = discounted[0]
        grossDiscounted = discounted[1]
      }
    } else {
      netDiscounted = net
      grossDiscounted = gross
    }

    const totalOpts = { ...this.priceSetup, app_digits: 2 }

    this.summaryNetTarget.textContent = formatNumber(net, totalOpts)
    this.summaryNetDiscountedTarget.textContent = formatNumber(netDiscounted, totalOpts)
    this.summaryGrossTarget.textContent = formatNumber(gross, totalOpts)
    this.summaryGrossDiscountedTarget.textContent = formatNumber(grossDiscounted, totalOpts)
    this.summaryTotalDiscountGrossTarget.textContent = formatNumber(gross - grossDiscounted, totalOpts)
    this.summaryTaxTarget.textContent = formatNumber(gross - net, totalOpts)
    this.summaryTaxDiscountedTarget.textContent = formatNumber(grossDiscounted - netDiscounted, totalOpts)

    if (this.hasArrDueAmountTarget) {
      this.calculateArrDue(net)
    }

    // if ($('#invoice_prime_cee_value').is(':visible')) { #TODO
    //   this.calculate_prime_cee();
    // }
  }

  updateArrFeeRate(rate) {
    this.arrFeeRateValue = rate
    this.calculateTotalSum()
  }

  toggleArrDueRow(hidden) {
    if (this.hasArrDueRowTarget) {
      this.arrDueRowTarget.classList.toggle("hidden", hidden)
    }
  }

  calculateArrDue(net) {
    const rate = this.arrFeeRateValue
    let due

    if (rate === "0,001 zł / kg") {
      let quantity = 0
      for (let i = 0; i < this.newPositionId; i++) {
        const quantityField = document.getElementById("invoice_positions_attributes_" + i + "_quantity")
        const totalPriceNetField = document.getElementById("invoice_positions_attributes_" + i + "_total_price_net")
        if (!quantityField || !totalPriceNetField || totalPriceNetField.value.length === 0) {
          continue
        }
        quantity += parseNumber(quantityField.value, this.priceSetup)
      }
      due = Math.round(quantity * 0.001)
    } else if (rate === "0,2%") {
      due = Math.round(net * 0.002)
    } else {
      due = Math.round(net * 0.001)
    }

    this.arrDueAmountTarget.textContent = formatNumber(due, { ...this.priceSetup, app_digits: 2 })
    if (this.hasArrDueLabelTarget) {
      this.arrDueLabelTarget.textContent = this.arrDueLabelPrefixValue + rate
    }
  }

  // "disabled" (dokumenty bez podatku, np. NO_TAX_KINDS) → 0 zamiast NaN z parseNumber("disabled")
  parseTaxRate(el, { requireSelect = false } = {}) {
    if (!el || el.value === "disabled") return 0
    if (requireSelect && el.tagName !== "SELECT") return 0
    return parseNumber(el.value, this.priceSetup)
  }

  calcDiscounted(part) {
    const itemsCount = this.newPositionId // ile jest wierszy (produkty + linie tekstowe + podział strony)
    if (typeof part === "undefined") {
      part = ""
    }
    let netDiscountedLocal = 0 // suma netto po rabacie
    let grossDiscountedLocal = 0 // suma brutto suma netto po rabacie
    const invoiceDigits = this.priceSetup.app_digits
    // loop po pozycjach
    for (let i = 0; i < itemsCount; i++) {
      const prefixElem = "invoice_positions_attributes_" + i + part
      // defensywnie: dla indeksu bez wyrenderowanego pola pozycji getElementById zwraca null
      const totalPriceNetField = document.getElementById(prefixElem + "_total_price_net")
      // sprawdzenie na polu z totalem (nie destroy), żeby było spójnie ze zliczaniem net i gross (i tak jest czyszczone)
      if (!totalPriceNetField || totalPriceNetField.value.length === 0) {
        continue
      }

      // separatory (page_break, subtotal, linia tekstowa) nie są pozycjami — mają total_price_* = "0"
      // i tax = "disabled", więc nie łapie ich guard wyżej, ale wpadają do case'a rabatu i psują sumę
      // po rabacie. Wykluczamy je po kind, jak serwer w InvoicePosition#generate_products.
      // (Lustrzana kopia guarda w app/assets/javascripts/fakturownia.js.erb — keep in sync.)
      const posKind = document.getElementById(prefixElem + "_kind")?.value
      if (["page_break", "text_separator", "subtotal", "subtotal_with_quantity", "subtotal_with_weight"].includes(posKind)) {
        continue
      }

      // tax2El jest <select> gdy widoczny (wartość "disabled" gdy tax niewidoczny) lub <input type="hidden"> gdy niewidoczny;
      // tax jest zawsze <select> (ukrywany tylko CSS-em), stąd bez wymogu tagName
      const tax2 = this.parseTaxRate(document.getElementById(prefixElem + "_tax2"), { requireSelect: true })
      const tax = this.parseTaxRate(document.getElementById(prefixElem + "_tax"))

      const discountPercentRaw = parseNumber(document.getElementById(prefixElem + "_discount_percent").value, this.priceSetup)
      const item = {
        discout_percent: discountPercentRaw / 100,
        discout_percent_raw: discountPercentRaw,
        discout_amount: parseNumber(document.getElementById(prefixElem + "_discount").value, this.priceSetup),
        quantity: parseNumber(document.getElementById(prefixElem + "_quantity").value, this.priceSetup),
        price_net: parseNumber(document.getElementById(prefixElem + "_price_net").value, this.priceSetup),
        price_gross: parseNumber(document.getElementById(prefixElem + "_price_gross").value, this.priceSetup),
        tax: (tax + tax2) / 100,
        total_price_net: parseNumber(document.getElementById(prefixElem + "_total_price_net").value, this.priceSetup),
        total_price_gross: parseNumber(document.getElementById(prefixElem + "_total_price_gross").value, this.priceSetup),
      }

      if (this.invoiceOutlet.localeValue === "fr" && item.discout_amount.valueOf() === 0) {
        item.net_discounted = item.total_price_net
        item.gross_discounted = item.total_price_gross
      } else {
        // switch po rodzajach rabatu
        // metody liczenia (procentowych typów) niby są różne (zgodnie z opisem), ale ostatecznie to wychodzi na to samo
        // (jak się nie zaokrągla po drodze). Pytanie czy nie lepiej to uprościć?
        switch (this.invoiceOutlet.discountKindValue) {
          case "percent_unit": // procentowo od ceny jednostkowej netto
            // tu zaokrągliłem na razie, żeby było spójne z wartościami po zapisaniu
            item.net_discounted = (item.price_net - item.price_net * item.discout_percent).toFixed(invoiceDigits) * item.quantity
            item.gross_discounted = item.net_discounted + item.net_discounted * item.tax
            break
          case "percent_total": { // procentowo od ceny całkowitej (liczone od brutto — spójnie z serwerem)
            // half-away-from-zero (jak BigDecimal round_price na serwerze); Math.round zaokrągla połówki ku +∞
            const cents = Math.round(item.total_price_gross * 100) * item.discout_percent_raw / 100
            const discountCents = Math.sign(cents) * Math.round(Math.abs(cents))
            item.gross_discounted = parseFloat((item.total_price_gross - discountCents / 100).toFixed(2))
            // ratio zerujemy tylko dla brutto == 0 (jak serwer); ujemne (korekty) liczymy normalnie.
            // half-away-from-zero na netto (jak discount_net na serwerze); .toFixed(2) zaokrąglało ujemne ku zeru → grosz różnicy
            const netRaw = item.total_price_net * item.gross_discounted / item.total_price_gross
            item.net_discounted = item.total_price_gross !== 0 ? Math.sign(netRaw) * Math.round(Math.abs(netRaw) * 100) / 100 : 0
            break
          }
          case "percent_unit_gross": // procentowo od ceny jednostkowej brutto
            // przy 0% rabatu nie stosujemy formuły per-unit, żeby uniknąć kumulacji błędów
            // zaokrąglenia price_gross (zaokrąglone) vs total_price_gross (z netto)
            item.gross_discounted = item.discout_percent === 0
              ? item.total_price_gross
              : (item.price_gross - item.price_gross * item.discout_percent) * item.quantity
            item.net_discounted = item.gross_discounted / (1 + item.tax)
            break
          case "amount": // od wartości brutto (totala na produkcie)
            item.gross_discounted = item.total_price_gross - item.discout_amount
            item.net_discounted = item.gross_discounted / (1 + item.tax)
            break
          default:
        }
      }

      netDiscountedLocal += item.net_discounted
      grossDiscountedLocal += item.gross_discounted
    }
    return [netDiscountedLocal, grossDiscountedLocal]
  }

  addMoreFields(event) {
    const elem = event.currentTarget
    if (event.params.fieldKind === "discount") {
      this.invoiceOutlet.discountTarget.click()
      elem.querySelector("[data-icon-open]").classList.toggle("hidden", this.invoiceOutlet.discountTarget.checked)
      elem.querySelector("[data-icon-close]").classList.toggle("hidden", !this.invoiceOutlet.discountTarget.checked)
    }

    // TODO
    // if (!$('#invoice_additional_info').prop('checked')){
    //  $('.row0_v2').addClass("row0").removeClass('row0_v2');
    //  $('.field0_v2').addClass("field0").removeClass('field0_v2');
    //  $('.more_d').hide();
    //  $('.show_more_d').show('fast');
    //  $('#label_checkbox2').removeClass("clicked");
    //  $('#show_additional_info_button').html("dodaj PKWiU");
    // } else {
    //  new_name_col_sm_size -= 1;
    //  $('.row0').addClass("row0_v2").removeClass('row0');
    //  $('.field0').addClass("field0_v2").removeClass('field0');
    //  $('.more_d').show();
    //  $('.show_more_d').hide();
    //  $('#label_checkbox2').addClass("clicked");
    //  $('#show_additional_info_button').html("ukryj PKWiU");
    // };
  }
}
